import { DISTRETTI } from '../data/geodata'
import type { AmbitoId } from '../data/ambitiStats'
import type { SezioneCard } from '../components/SectionBadge'

export type CompareAmbitiPoint = {
  id: AmbitoId
  name: string
  value: number
  color: string
}

export const AMBITO_COMPARE_COLORS: Record<AmbitoId, string> = {
  carate: DISTRETTI.carate.colorHex,
  desio: DISTRETTI.desio.colorHex,
  monza: DISTRETTI.monza.colorHex,
  seregno: DISTRETTI.seregno.colorHex,
  vimercate: DISTRETTI.vimercate.colorHex,
}

export const AMBITO_LABELS: Record<AmbitoId, string> = {
  carate: 'Carate',
  desio: 'Desio',
  monza: 'Monza',
  seregno: 'Seregno',
  vimercate: 'Vimercate',
}

export const CHART_TOOLTIP_STYLE = {
  wrapperStyle: {
    zIndex: 80,
  },
  contentStyle: {
    background: 'var(--tooltip-bg)',
    border: '1px solid var(--tooltip-border)',
    borderRadius: 8,
    fontSize: 12,
    color: 'var(--tooltip-text)',
  },
}

export function formatInt(value: number) {
  return new Intl.NumberFormat('it-IT').format(value)
}

export function formatEuro(value: number) {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(value)
}

export function formatDecimal(value: number) {
  return new Intl.NumberFormat('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(value)
}

export function formatDecimalWithThousands(value: number) {
  return new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    useGrouping: true,
  }).format(value)
}

export function formatSignedPercent(value: number) {
  const sign = value >= 0 ? '+' : '-'
  return `${sign}${formatDecimal(Math.abs(value))}%`
}

export function computeRelativeChange(series: Array<{ valore: number }>) {
  const first = series[0]?.valore ?? 0
  const last = series[series.length - 1]?.valore ?? 0
  if (first === 0) return 0
  return ((last - first) / first) * 100
}

export function computeDeltaPoints(series: Array<{ valore: number }>) {
  const first = series[0]?.valore ?? 0
  const last = series[series.length - 1]?.valore ?? 0
  return last - first
}

export { type SezioneCard }
